/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface Step1Data {
  /** @maxLength 100 */
  first_name: string;
  /** @maxLength 100 */
  last_name: string;
  phone?: string | null;
  timezone?: string;
  avatar_url?: string | null;
}
